import { Box, HStack, Icon, Text, VStack, makeUclComponent } from '@rbilabs/universal-components';

import { HorizontalPosition } from 'components/features/components/typography-block';
import { MarketingBasicTile } from 'components/marketing-basic-tile';

export const InRestaurantRedemptionEntryContainer = makeUclComponent(Box).withConfig<{
  newUI?: boolean;
}>(p => ({
  borderStyle: 'solid',
  borderTopWidth: '1',
  borderColor: Styles.color.grey.five,
  borderRadius: p.newUI ? '10px' : null,
  borderWidth: p.newUI ? '1px' : null,
  marginX: p.newUI ? '$4' : null,
  marginBottom: p.newUI ? '$2' : null,
}));

export const InRestaurantRedemptionEntryContent = HStack.withConfig({
  width: 'full',
  alignItems: 'center',
  paddingX: '$2.5',
  paddingY: '$3.5',
});

export const InRestaurantRedemptionList = VStack.withConfig({
  // ul
  margin: '$4',
  padding: '$0',
  borderRadius: 'xl',
  overflow: 'hidden',
});

export const PictureAndDetails = HStack.withConfig({
  flex: 1,
});

export const RewardDetails = VStack.withConfig({
  flex: 1,
  marginLeft: '$4',
  marginRight: '$2',
  justifyContent: 'center',
});

export const WrapperName = VStack.withConfig({
  width: 'full',
  marginBottom: '$2',
});

export const StyledIconX = Icon.withConfig({
  variant: 'cancel',
  color: Styles.color.black,
  size: 'xs',
  marginLeft: '$2',
});

export const EmptyState = Box.withConfig({
  padding: '$4',
  alignItems: 'center',
  fontSize: 'sm',
  flexDirection: 'row',
  alignSelf: 'center',
});

export const EmptyStateText = Text.withConfig({
  color: Styles.color.primary,
  marginY: '$0',
  marginX: '$1',
  textDecorationLine: 'underline',
});

export const EmptyCartWidgetStyled = MarketingBasicTile.withConfig({
  padding: '$4',
  backgroundColor: Styles.color.white,
  borderRadius: Styles.borderRadius,
  marginY: '$2',
  marginX: '$4',

  _basicTileTitle: {
    color: Styles.color.black,
    fontSize: 'lg',
    lineHeight: '2xs',
    textAlign: 'center',
  },
  _typographyBlock: {
    horizontalPosition: HorizontalPosition.CENTER,
    color: Styles.color.black,
    lineHeight: 'md',
    fontSize: 'md',
    marginY: '$4',
  },
});
